export default "__VITE_ASSET__BEPY3l9c__"